import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { useEffect, useState } from 'react'
import { Box, Chip, Stack, Typography } from '@mui/material'
import { isEmpty } from 'lodash'
import {
  ModernDialogActions,
  ModernDialogContent,
  primaryActionSx,
  questionnaireDialogSx,
  questionnairePaperSx,
} from '../QuestionnaireDialogFrame'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
const tagKeyMap = { Nul: 'tagNul', Faible: 'tagFaible', Moyen: 'tagMoyen', Expert: 'tagExpert' } // LAP-733 (GE022)
const messages = [
  {
    box: 'Base',
    data: [
      {
        box: 'Base',
        score: 0,
        tag: 'Nul',
        img: '/score0.png',
        text: 'Si vous êtes complètement novice en matière de finances personnelles, commencez par établir un budget. Listez toutes vos sources de revenus et vos dépenses mensuelles. Utilisez cet aperçu pour identifier les domaines où vous pouvez économiser. Le simple fait de savoir où va votre argent peut faire une énorme différence.',
      },
      {
        box: 'Base',
        score: 1,
        tag: 'Faible',
        img: '/score1.png',
        text: 'Si vous êtes complètement novice en matière de finances personnelles, commencez par établir un budget. Listez toutes vos sources de revenus et vos dépenses mensuelles. Utilisez cet aperçu pour identifier les domaines où vous pouvez économiser. Le simple fait de savoir où va votre argent peut faire une énorme différence.',
      },
      {
        box: 'Base',
        score: 2,
        tag: 'Moyen',
        img: '/score2.png',
        text: "Si vous avez déjà un budget et que vous comprenez les bases de l'épargne, la prochaine étape est d'établir un fonds d'urgence. L'objectif est d'avoir assez d'argent pour couvrir au moins 3 à 6 mois de dépenses essentielles. Cela vous donnera une certaine tranquillité d'esprit et une marge de manœuvre en cas d'urgence financière.",
      },
      {
        box: 'Base',
        score: 3,
        tag: 'Expert',
        img: '/score3.png',
        text: "Si vous êtes déjà à l'aise avec le budget, l'épargne, et peut-être même l'investissement, pensez à optimiser vos finances pour minimiser vos obligations fiscales. Cela pourrait impliquer de maximiser les contributions à des comptes de retraite à avantages fiscaux, ou d'utiliser des stratégies de donation pour minimiser les impôts sur les successions, par exemple.",
      },
    ],
  },
  {
    box: 'Produit',
    data: [
      {
        box: 'Produit',
        score: 0,
        tag: 'Nul',
        img: '/score0.png',
        text: "Avant de choisir n'importe quel produit financier, définissez clairement vos objectifs financiers : épargner pour la retraite, acheter une maison, financer les études de vos enfants, etc. Ensuite, regardez les produits financiers de base qui peuvent vous aider à atteindre ces objectifs, comme un compte d'épargne ou un fonds indiciel simple.",
      },
      {
        box: 'Produit',
        score: 1,
        tag: 'Faible',
        img: '/score1.png',
        text: "Avant de choisir n'importe quel produit financier, définissez clairement vos objectifs financiers : épargner pour la retraite, acheter une maison, financer les études de vos enfants, etc. Ensuite, regardez les produits financiers de base qui peuvent vous aider à atteindre ces objectifs, comme un compte d'épargne ou un fonds indiciel simple.",
      },
      {
        box: 'Produit',
        score: 2,
        tag: 'Moyen',
        img: '/score2.png',
        text: 'Vous avez probablement déjà une idée des différents types de produits financiers. Maintenant, apprenez à examiner les frais associés et les rendements historiques. Les fonds qui prélèvent des frais élevés peuvent rapidement grignoter vos gains. Des outils comme les ratios de Sharpe ou de Sortino peuvent vous aider à évaluer le rendement ajusté au risque.',
      },
      {
        box: 'Produit',
        score: 3,
        tag: 'Expert',
        img: '/score3.png',
        text: "En tant qu'expert, vous pouvez envisager des produits plus complexes tels que les produits dérivés, les fonds spéculatifs ou les investissements en capital privé. Toutefois, ces produits viennent souvent avec un degré de risque et de complexité plus élevé. Assurez-vous de bien comprendre les mécanismes, les risques et les frais associés avant de vous engager.",
      },
    ],
  },
  {
    box: 'Bourse',
    data: [
      {
        box: 'Bourse',
        score: 0,
        tag: 'Nul',
        img: '/score0.png',
        text: "Si vous êtes nouveau dans le monde de la bourse, il peut être préférable de commencer par investir dans des fonds indiciels ou des ETF (Fonds Négociés en Bourse) qui suivent des indices boursiers majeurs comme le S&P 500. C'est une façon moins risquée de se familiariser avec le marché tout en diversifiant votre portefeuille.",
      },
      {
        box: 'Bourse',
        score: 1,
        tag: 'Faible',
        img: '/score1.png',
        text: "Si vous êtes nouveau dans le monde de la bourse, il peut être préférable de commencer par investir dans des fonds indiciels ou des ETF (Fonds Négociés en Bourse) qui suivent des indices boursiers majeurs comme le S&P 500. C'est une façon moins risquée de se familiariser avec le marché tout en diversifiant votre portefeuille.",
      },
      {
        box: 'Bourse',
        score: 2,
        tag: 'Moyen',
        img: '/score2.png',
        text: 'À ce stade, vous avez probablement déjà quelques connaissances sur les actions, les obligations et peut-être même les matières premières. Essayez de comprendre votre tolérance au risque et diversifiez en conséquence. Vous pouvez commencer à inclure des actifs plus risqués comme des actions individuelles, des fonds sectoriels ou des monnaies numériques pour améliorer votre potentiel de rendement.',
      },
      {
        box: 'Bourse',
        score: 3,
        tag: 'Expert',
        img: '/score3.png',
        text: "Si vous êtes déjà à l'aise avec les différents types d'actifs et les dynamiques du marché, vous pourriez envisager des stratégies plus complexes. Par exemple, l'utilisation d'options pour le hedging (couverture) peut vous aider à protéger vos gains ou minimiser les pertes. Les dérivés peuvent être risqués et complexes, donc assurez-vous de bien comprendre les mécanismes avant de plonger.",
      },
    ],
  },
  {
    box: 'Immobilier',
    data: [
      {
        box: 'Immobilier',
        score: 0,
        tag: 'Nul',
        img: '/score0.png',
        text: 'Avant d\'investir dans l\'immobilier, il est crucial de se familiariser avec les bases. Lisez des livres, suivez des cours en ligne et parlez à des personnes qui ont déjà investi. Comprendre les termes comme "retour sur investissement" (ROI), "coût d\'opportunité", et "amortissement" vous aidera à prendre des décisions plus éclairées.',
      },
      {
        box: 'Immobilier',
        score: 1,
        tag: 'Faible',
        img: '/score1.png',
        text: 'Avant d\'investir dans l\'immobilier, il est crucial de se familiariser avec les bases. Lisez des livres, suivez des cours en ligne et parlez à des personnes qui ont déjà investi. Comprendre les termes comme "retour sur investissement" (ROI), "coût d\'opportunité", et "amortissement" vous aidera à prendre des décisions plus éclairées.',
      },
      {
        box: 'Immobilier',
        score: 2,
        tag: 'Moyen',
        img: '/score2.png',
        text: "Vous connaissez déjà les bases, alors poussez votre analyse un peu plus loin. Utilisez des outils et des modèles financiers pour évaluer le potentiel d'un investissement. Considérez tous les coûts, pas seulement le prix d'achat : frais de notaire, travaux de rénovation, coûts de gestion, etc. De même, soyez réaliste quant aux revenus potentiels, qu'il s'agisse de location ou de revente.",
      },
      {
        box: 'Immobilier',
        score: 3,
        tag: 'Expert',
        img: '/score3.png',
        text: 'Vous avez probablement déjà un portefeuille solide. À ce stade, envisagez de diversifier en termes de localisation géographique et de types de propriétés (résidentiel, commercial, terrains, etc.). Chaque marché a ses propres risques et opportunités, et la diversification peut vous aider à atténuer les risques spécifiques à un marché ou un type de bien.',
      },
    ],
  },
  {
    box: 'Final',
    data: [
      {
        box: 'Final',
        score: 0,
        tag: 'Nul',
        img: '/score0.png',
        text: 'Lisez un livre ou suivez un cours en ligne sur les finances personnelles.',
      },
      {
        box: 'Final',
        score: 1,
        tag: 'Faible',
        img: '/score1.png',
        text: 'Commencez par suivre un budget',
      },
      {
        box: 'Immobilier',
        score: 2,
        tag: 'Moyen',
        img: '/score2.png',
        text: 'Apprenez à investir intelligemment.',
      },
      {
        box: 'Final',
        score: 3,
        tag: 'Expert',
        img: '/score3.png',
        text: "Considérez la fiscalité et l'optimisation fiscale comme une composante de votre stratégie financière globale",
      },
    ],
  },
]
export default function MessageBox({ value, page, setOpenFiKnowledge }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(true)
  const [mdata, setMData] = useState(false)

  useEffect(() => {
    messages.forEach((e) => {
      if (e.box === page) {
        setMData(e.data[value])
      }
    })
    // setMData(messages.data[value])
  }, [])

  // const handleClickOpen = () => {
  //   setOpen(true)
  // }

  // const handleCloseX = () => {
  //   setOpen(false)
  //   setOpenFiKnowledge(0)
  // }
  const handleClose = () => {
    setOpen(false)
    if (page === 'Base') {
      if (value === 0) setOpenFiKnowledge(0)
      if (value === 1) setOpenFiKnowledge(0)
      if (value === 2) setOpenFiKnowledge(2)
      if (value === 3) setOpenFiKnowledge(2)
    }
    if (page === 'Produit') {
      if (value === 0) setOpenFiKnowledge(0)
      if (value === 1) setOpenFiKnowledge(0)
      if (value === 2) setOpenFiKnowledge(3)
      if (value === 3) setOpenFiKnowledge(3)
    }
    if (page === 'Bourse') {
      setOpenFiKnowledge(4)
    }
    if (page === 'Final') {
      setOpenFiKnowledge(0)
    }
    if (page === 'Immobilier') {
      if (value !== 0) {
        setOpenFiKnowledge(5)
      } else {
        setOpenFiKnowledge(0)
      }
    }
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        className="no-drag"
        PaperProps={{ sx: questionnairePaperSx }}
        sx={questionnaireDialogSx}
      >
        <ModernDialogContent>
          <Box
            display={'flex'}
            justifyContent={'center'}
            flexDirection={'column'}
            alignItems={'center'}
            position={'relative'}
            textAlign="center"
            sx={{ py: 1 }}
          >
            {/* <IconButton
              onClick={handleCloseX}
              sx={{ position: 'absolute', top: 0, right: 0 }}
              aria-label="fingerprint"
              color="secondary"
            >
              <CloseIcon sx={{ color: 'black' }} />
            </IconButton> */}
            <Box
              sx={{
                width: 150,
                height: 150,
                borderRadius: 4,
                display: 'grid',
                placeItems: 'center',
                bgcolor: '#ffffff',
                border: '1px solid rgba(20, 104, 183, 0.12)',
                boxShadow: '0 14px 34px rgba(16, 35, 63, 0.08)',
                mb: 2,
              }}
            >
              <img height={118} width={118} src={mdata?.img} alt="" />
            </Box>
            <Stack direction="row" gap={1} justifyContent="center" flexWrap="wrap" sx={{ mb: 1.4 }}>
              <Chip label={mdata.box} sx={{ bgcolor: '#e7f1fb', color: '#1468b7', fontWeight: 850 }} />
              <Chip label={mdata.tag ? t('monPatrimoine.' + (tagKeyMap[mdata.tag] || 'tagNul')) : ''} sx={{ bgcolor: '#edf7ef', color: '#227142', fontWeight: 850 }} />
              <Chip label={`${mdata.score}/3`} sx={{ bgcolor: '#fff3df', color: '#9b5d00', fontWeight: 850 }} />
            </Stack>
            <Typography sx={{ color: '#10233f', fontSize: 24, fontWeight: 900, mb: 1 }}>
              {t('monPatrimoine.messageBoxTitle')}
            </Typography>
            <Typography sx={{ color: '#4f657b', fontSize: 15.5, lineHeight: 1.55, maxWidth: 520 }}>
              {mdata.text}
            </Typography>
          </Box>
        </ModernDialogContent>
        <ModernDialogActions>
          <Button onClick={handleClose} variant="contained" type="submit" sx={primaryActionSx}>
            {t('monPatrimoine.continueButton')}
          </Button>
        </ModernDialogActions>
      </Dialog>
    </>
  )
}
